import {
    IClusterDetailsItem,
  IClusterListItem,
  IClusterPageRequestParams,
} from "api/entities/cluster";
import { DataService } from "./data-service";
import { IPage } from "api/entities/page";

class ClusterService extends DataService {
  constructor() {
    super("cluster", 2);
  }
  getPage(
    requestParams: IClusterPageRequestParams
  ): Promise<IPage<IClusterListItem>> {
    return this.api.get<IPage<IClusterListItem>>(null, requestParams);
  }

  get(clusterId: string): Promise<IClusterDetailsItem> {
    return this.api.get<IClusterDetailsItem>(clusterId, null);
  }

  getByStoragePoolId(id: string): Promise<IClusterDetailsItem> {
    return this.api.get<IClusterDetailsItem>(`by-pool/${id}`);
  }

  getByStoragePoolIds(poolIds: string[]): Promise<IPage<IClusterListItem>> {
    return this.api.post<IPage<IClusterListItem>>(`by-pool`, poolIds);
  }
}

export const clusterService = new ClusterService()
